export default __webpack_public_path__ + "static/media/img-8.62319528.jpg";